import { gql } from "@apollo/client";

const GET_HCP_PENDING_DOCS_COUNT = gql`
  query GET_HCP_PENDING_DOCS_COUNT($hcpId: ObjectId!) {
    pendingDocsCount(hcpId: $hcpId)
  }
`;

const GET_MISSING_REQS = gql`
  query GET_MISSING_REQS($hcpId: ObjectId!, $hcfId: ObjectId) {
    hcpMissingRequirements(hcpId: $hcpId, hcfId: $hcfId) {
      cbh
      state
      msa
      county
      hcf
    }
  }
`;

export { GET_HCP_PENDING_DOCS_COUNT, GET_MISSING_REQS };
